export default __webpack_public_path__ + "static/media/grafema_amcc_13.055df7ad.jpg";